import { Box, Button, FormControl, MenuItem, Select, Typography, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import HttpServices from 'src/services/httpService';
import { integrateModuleURL } from 'src/services/urlService';
import PinterestCreateBoard from './pinterest-create-board';
import { useTranslation } from 'react-i18next';

const BoardView = ({ profileId, profile, handleChangeBoard, handleChangeBoardSection }) => {
  const { t: translate } = useTranslation();
  const theme = useTheme();
  const [boards, setBoards] = useState([]);
  const [selectedBoardId, setSelectedBoardId] = useState('');
  const [selectedSectionId, setSelectedSectionId] = useState('');
  const [boardSections, setBoardSections] = useState([]);
  const [pinterestCreateBoardOpen, setPinterestCreateBoardOpen] = useState(false);

  const successCallback = (data) => {
  setBoards(data);

  if (!data || data.length === 0) return;

  // ---------- BOARD SELECTION ----------
  let selectedBoard = null;

  if (profile.board_id) {
    selectedBoard = data.find((b) => b.board_id === profile.board_id);
  }

  // fallback to first board
  if (!selectedBoard) {
    selectedBoard = data[0];
  }

  setSelectedBoardId(selectedBoard.board_id);
  handleChangeBoard(profileId, profile, selectedBoard.board_id);

  if (selectedBoard.board_sections && selectedBoard.board_sections.length > 0) {
    setBoardSections(selectedBoard.board_sections);

    let selectedSection = null;

    if (profile.board_section_id) {
      selectedSection = selectedBoard.board_sections.find(
        (s) => s.board_section_id === profile.board_section_id
      );
    }

    if (selectedSection) {
      setSelectedSectionId(selectedSection.board_section_id);
      handleChangeBoardSection(profileId, profile, selectedSection.board_section_id);
    } else {
      setSelectedSectionId('');
      handleChangeBoardSection(profileId, profile, '');
    }
  } else {
    setBoardSections([]);
    setSelectedSectionId('');
    handleChangeBoardSection(profileId, profile, '');
  }
};

  const failureCallback = (error) => {
    console.error('Error fetching boards:', error);
  };

  useEffect(() => {
    const getProps = {
      url: `${integrateModuleURL.FetchAllBoards}${profileId}`,
      successCallback,
      failureCallback,
    };
    HttpServices.Get(getProps);
  }, [profileId]);

  const handleActionChange = (newBoardId) => {
    setSelectedBoardId(newBoardId);
    handleChangeBoard(profileId, profile, newBoardId);

    const selectedBoard = boards.find((b) => b.board_id === newBoardId);

    if (selectedBoard?.board_sections?.length > 0) {
      setBoardSections(selectedBoard.board_sections);
      setSelectedSectionId('');
      handleChangeBoardSection(profileId, profile, '');
    } else {
      setBoardSections([]);
      setSelectedSectionId('');
      handleChangeBoardSection(profileId, profile, '');
    }
  };

  const handleCreateBoard = () => {
    setPinterestCreateBoardOpen(true);
  };

  const NewBoardCreationCallback = (newBoard) => {
    setBoards((prevBoards) => [...prevBoards, newBoard]);
    setSelectedBoardId(newBoard.board_id);
    setPinterestCreateBoardOpen(false);
    handleChangeBoard(profileId, profile, newBoard.board_id);
  };

  const handleClose = () => {
    setPinterestCreateBoardOpen(false);
  };

  return (
    <>
      <Typography style={{ color: theme.palette.text.secondary, ...theme.typography.subtitle2, marginBottom: '8px' }}>
        {translate('post_conditions.boards', 'Boards')}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, marginBottom: '8px' }}>
        <FormControl sx={{ flexGrow: 1 }}>
          <Select
            value={selectedBoardId}
            onChange={(event) => handleActionChange(event.target.value)}
            displayEmpty
            inputProps={{ 'aria-label': 'Without label' }}
            fullWidth
            size="small"
          >
            {!boards.length && (
              <MenuItem value="">{translate('post_conditions.no_boards_available', 'No boards available')}</MenuItem>
            )}
            {boards.map((board) => (
              <MenuItem key={board.board_id} value={board.board_id}>
                {board.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button variant="contained" onClick={handleCreateBoard} sx={{ whiteSpace: 'nowrap' }}>
          {translate('post_conditions.create_board', 'Create Board')}
        </Button>

        {pinterestCreateBoardOpen && (
          <PinterestCreateBoard
            handleClose={handleClose}
            profileId={profileId}
            NewBoardCreationCallback={NewBoardCreationCallback}
          />
        )}
      </Box>
      {boardSections.length > 0 && (
        <>
          <Typography
            style={{
              color: theme.palette.text.secondary,
              ...theme.typography.subtitle2,
              marginBottom: '8px',
            }}
          >
            {translate('post_conditions.board_sections', 'Board Sections (Optional)')}
          </Typography>

          <FormControl fullWidth size="small" sx={{ marginBottom: '8px' }}>
            <Select
              value={selectedSectionId}
              onChange={(e) => {
                setSelectedSectionId(e.target.value);
                handleChangeBoardSection(profileId, profile, e.target.value);
              }}
              displayEmpty
            >
              <MenuItem value="">{translate('post_conditions.select_section', 'Select Section')}</MenuItem>

              {boardSections.map((section) => (
                <MenuItem key={section.board_section_id} value={section.board_section_id}>
                  {section.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </>
      )}
    </>
  );
};

export default BoardView;
